import { Tabs } from "antd";
import '../../style/community.css';
import InvestQuizView from "../../components/user/quizz_invest_view";
import ProfilingQuizView from "../../components/user/quizz_profile_view";

const ProfilingQuizScreen = () => {

    const tabItems = [
        { label: 'Investment Quizz', key: '1', children: <InvestQuizView /> }, 
        { label: 'Community Quizz', key: '2', children: <ProfilingQuizView />}
    ];
    return (
        <div className='main-wrapper'>
            <div className='cnt-item'>
                <Tabs items={tabItems} tabBarStyle={{ paddingLeft: 16 }} />
            </div>

        </div>
    )
}

export default ProfilingQuizScreen;